/* Hana Prints — custom storefront JS */

(function () {
  function toThumbGrid($el) {
    if (!$el || !$el.length) return;

    try {
      if ($el.hasClass('slick-initialized') && typeof $el.slick === 'function') {
        $el.slick('unslick');
      }
    } catch (e) {
      /* ignore */
    }

    $el.addClass('mm-thumbs-grid');
    $el.find('.slick-list, .slick-track').contents().unwrap();
    $el.find('.slick-slide').each(function () {
      var $slide = $(this);
      if ($slide.parent().is($el)) return;
      $slide.children().first().unwrap();
    });
    $el.find('.slick-arrow, .slick-cloned').remove();
  }

  function fixProductThumbs() {
    if (typeof window.jQuery === 'undefined') return;
    var $ = window.jQuery;
    var $thumbs = $('.template-product .productView-for');
    if (!$thumbs.length) return;
    toThumbGrid($thumbs);
  }

  function boot() {
    fixProductThumbs();
    // Theme inits slick after load — re-run shortly after
    window.setTimeout(fixProductThumbs, 400);
    window.setTimeout(fixProductThumbs, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    window.setTimeout(fixProductThumbs, 200);
  });
})();
